/**
 * 录制状态
 */
export enum RecorderStatus {
  /**
   * 请求中
   */
  REQUEST = 0,
  /**
   * 倒计时
   */
  COUNTDOWN = 1,
  /**
   * 录制中
   */
  RUNNING = 2,
  /**
   * 已暂停
   */
  PAUSED = 3,
  /**
   * 已停止
   */
  STOPPED = 4
}

/**
 * 录制状态存储
 */
export interface RecorderState {
  /**
   * 状态
   */
  status: RecorderStatus;
  /**
   * 倒计时
   */
  countdown: number;
  /**
   * 剩余时间
   */
  remain: number;
  /**
   * 是否启用麦克风
   */
  enableMic: boolean;
  /**
   * 是否启用摄像头
   */
  enableCam: boolean;
}

export interface RecorderOptions {
  /**
   * 录制的issueId
   */
  issueId: number;
  /**
   * 从哪里点击的录制
   */
  from: string;
}
